import styled from 'styled-components'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

export const Wrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    min-height: 90px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 24px;
    img {
        border-radius: 6px;
    }

    @media ${respondAbove.xl} {
        border-bottom: 2px solid ${({ theme }) => theme.colors.grayscale_200};
        border-radius: 0;

        &:last-child {
            border-bottom: 0;
        }
    }

    & > ${Box}:first-of-type {
        background-color: ${({ theme }) => theme.colors.grayscale_100};
        @media ${respondAbove.xl} {
            background-color: initial;
        }
        & > ${Box}:first-of-type {
            border-bottom: 2px solid
                ${({ theme }) => theme.colors.grayscale_200};

            @media ${respondAbove.xl} {
                border-bottom: 0 solid
                    ${({ theme }) => theme.colors.grayscale_200};
            }
        }
    }

    @media ${respondAbove.xl} {
        img {
            border-radius: 8px 0 0 8px;
        }
    }
`
